import { css } from 'lit';

/**
 * SideBarGroupItemText CSS
 */
export const styles = css`
  :host {
    display: block;
    flex: 1 1 auto;        
    min-width: 0;         
    font-size: var(--nile-type-scale-3, var(--ng-font-size-text-md));  
    line-height: var(--nile-line-height-small);
    font-weight: var(--nile-font-weight-medium, var(--ng-font-weight-medium));
    font-family: var(--nile-font-family-serif, var(--ng-font-family-body));
    color: var(--nile-colors-dark-900, var(--ng-colors-text-secondary-700));
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  ::slotted(*) {
    font: inherit;
    color: inherit;
  }
  :host([collapsed]) {
    display: none;
  }
`;

export default [styles];
